var isOverIFrame = false;

const resizeIFrameToFitContent = function(iFrame) {
  if (!iFrame) {
    return false;
  }

  try {
      // console.log( iFrame.contentWindow.document.body.scrollHeight );
    let iFrameBody = iFrame.contentWindow.document.body;
      // console.log( iFrame.style.minHeight );
    iFrame.style.minHeight = ( 20 + iFrameBody.scrollHeight )  + 'px';
      // console.log( iFrame.style.minHeight );
  } catch (error) {
    
  }
};


const processMouseOut = function() {
  isOverIFrame = false;
  top.focus();
}
const processMouseOver = function() { 
  isOverIFrame = true;
}

/**
 * Event: Started
 * Attaching events so that processIFrameClick() can work.
 */
window.attachIframeClickEvent = function(processIFrameClick, iFrames){
  var element = iFrames || document.getElementsByTagName("iframe");
  for (var i=0; i<element.length; i++) {
      element[i].onmouseover = processMouseOver;
      element[i].onmouseout = processMouseOut;
  }
  if (typeof window.attachEvent != 'undefined') {
      top.attachEvent('onblur', function(event){
        if(isOverIFrame){
          processIFrameClick.call(document.activeElement, event);
        }
      });
  }
  else if (typeof window.addEventListener != 'undefined') {
      top.addEventListener('blur', function(event){
        if(isOverIFrame){
          processIFrameClick.call(document.activeElement, event);
        }
      }, false);
  }
}

const inView = function(obj){
  //Window Object
  var win = jQuery(window);
  //the top Scroll Position in the page
  var scrollPosition = win.scrollTop();
  //the end of the visible area in the page, starting from the scroll position
  var visibleArea = win.scrollTop() + win.height();
  //the end of the object to check
  var objEndPos = (obj.offset().top + obj.outerHeight());
  return((scrollPosition - 125) <= objEndPos && (scrollPosition + 125) >= obj.offset().top ? true : false)
};

const Iframes = function() {
  const iframes = document.querySelectorAll("iframe");
  if (0 < iframes.length) {
    Array.prototype.slice.call(iframes).forEach(iframe => {
      resizeIFrameToFitContent(iframe);
    });
  }
  
  const donation_form_iframe = document.querySelectorAll(".single-donation-form__iframe, .single-calendar-form, #iframetickets iframe");
  if(donation_form_iframe.length){
    attachIframeClickEvent(function(event){
      this.classList.add("form-expanded");
  
    }, donation_form_iframe);
  }

  
  var iFrames = jQuery("iframe[src *='veevartapp.com']");
  var header  = jQuery("header");
  jQuery(window).scroll(function(){ 
    iFrames.each(function() {
      var iframe = jQuery(this);
      if(inView(iframe) && !header.has('.nav__big--open').length){
        header.hide();
      }
      else{
        header.show();
      }
    });

  });
  
};

module.exports = Iframes;
